"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityQuery = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const Entities_1 = require("./enums/Entities");
class EntityQuery extends base_models_1.Serializable {
}
exports.EntityQuery = EntityQuery;
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)(Entities_1.Entity),
    (0, base_models_1.Docs)({
        example: Entities_1.Entity.Example,
        description: 'existence of such an entity for this customer',
    }),
    tslib_1.__metadata("design:type", String)
], EntityQuery.prototype, "entity", void 0);
